import { FormConfigContext } from '../sb-form-configuration/sb-form-context';
import { Injectable } from '@angular/core';
import { SbDataService } from './sb-data.service';
import { SbHost } from '@models';
import { forkJoin, Observable, of } from 'rxjs';
import { map, flatMap, tap } from 'rxjs/operators';
import { getObjectByKeyValue } from '@utils';
import { AppConfigQuery } from '../../core/state/app-config/app-config.query';

@Injectable({
    providedIn: 'root'
})
export class SbFormContextService {
    formPath = 'form-config';

    constructor(private dataService: SbDataService, private appConfig: AppConfigQuery) {}

    getFormConfig(id: string, entityId: string): Observable<FormConfigContext> {
        return this.dataService
            .getResource({ resource: this.formPath }, SbHost.FormConfigBaseUrl, id)
            .pipe(
                flatMap((context) => this.getContextWithOptionData(context)),
                flatMap((context) => this.getContextWithModelData(context, entityId))
            );
    }

    private getContextWithOptionData(
        context: FormConfigContext
    ): Observable<FormConfigContext> {
        if (context.optionDatas) {
            const formContextWithOptionsSet = context.optionDatas.reduce(
                (prev, cur) => [
                    ...prev,
                    this.dataService
                        .getData(
                            `${this.appConfig.getBaseUrl(
                                context.path,
                                SbHost.GatewayBaseUrl
                            )}/${cur.path}`
                        )
                        .pipe(
                            tap((data) => {
                                const object = getObjectByKeyValue(
                                    'key',
                                    cur.key,
                                    context.formlyFieldConfigs
                                );
                                if (object) {
                                    object.templateOptions.options = data;
                                }
                            })
                        )
                ],
                []
            );
            return forkJoin(formContextWithOptionsSet).pipe(map((_) => context));
        }
        return of(context);
    }

    private getContextWithModelData(
        context: FormConfigContext,
        entityId: string
    ): Observable<FormConfigContext> {
        if (entityId) {
            return this.getContextModel(entityId, context).pipe(
                map((model) => {
                    context.model = model;
                    return context;
                })
            );
        } else {
            return of(context);
        }
    }

    private getContextModel(
        entityId: string,
        context: FormConfigContext
    ): Observable<any> {
        return this.dataService.getResource(
            context.path,
            SbHost.GatewayBaseUrl,
            entityId
        );
    }
}
